<script>
import { authComputed, authMethods } from '@state/helpers'
import store from '@state/store'
import { profileQuestions } from '@services/safehaven/ProfileQuestionnaire'
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import Checkbox from '@components/questions/checkbox/quick-checkbox.vue'
import Button from '@components/questions/button/quick-button.vue'
import Emoji from '@components/questions/emoji/quick-emoji.vue'
import Radio from '@components/questions/radio/quick-radio.vue'
import { profileQuestionnaireComputed } from '@state/profileQuestionnaireHelper'
import * as _ from 'lodash'
export default {
  page: {
    title: 'Profile Questionnaire',
    meta: [{ name: 'description', content: 'The Profile Questionnaire page.' }],
  },
  components: {
    Checkbox,
    Button,
    Radio,
    Emoji,
  },
  mixins: [layout, NavigateMixin],
  data() {
    return {
      disable: true,
      questions: {},
      question_id: '',
      answers: {},
      answersData: {
        user_id: this.userId,
        user_response: [],
      },
      resetClick: false,
      submitted: false,
    }
  },
  computed: {
    ...authComputed,
    ...profileQuestionnaireComputed,
    user() {
      return this.serializedUser
    },
    desktopSlides() {
      return this.slides.filter((el) => !el.mobileOnly)
    },
  },
  watch: {
    profileQuestionnaire(newValue, oldValue) {
      this.questions = _.cloneDeep(newValue, true)
    },
    questions: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          const filteredValue = []
          newValue.filter((question) => {
            const index = _.findIndex(this.questions, (ques) => {
              return ques.id === question.id
            })

            // eslint-disable-next-line no-unused-expressions
            this.resetClick && _.isEmpty(question.answers)
              ? this.$set(this.questions, index, question)
              : null
            this.resetClick = false
            // eslint-disable-next-line no-undef
            return !question.answers || _.isEmpty(question.answers)
              ? filteredValue.push(question)
              : []
          })
          // eslint-disable-next-line no-unneeded-ternary
          this.disable = filteredValue.length === 0 ? false : true
        }
      },
    },
  },
  mounted() {
    // Get User Data
    const userData = JSON.parse(localStorage.getItem('auth.currentUser'))
    if (userData && userData.user.answer_saved) {
      this.$router.push({ name: 'safehaven-dashboard' })
    } else {
      this.answersData.user_id = userData.user.user_id
      store.dispatch('profileQuestionnaire/setQuestionnaire', true)
    }
  },

  methods: {
    ...authMethods,
    // ...questionnaireMethods,
    checkForm() {
      this.questions.map((res) => {
        if (!res.answers) {
          this.disable = true
        }

        const ansData = {
          question_id: res.question_id,
          answers: res.answers,
        }
        this.answersData.user_response.push(ansData)
      })
      this.saveAnswers()
      this.$router.push({ name: 'thank-you' })
    },
    async saveAnswers() {
      try {
        const responseData = await profileQuestions.saveAllAnswers(
          this.answersData,
          await this.updateUserSettings({ answer_saved: true })
        )

        if (responseData) {
        }
      } catch (error) {
        console.warn(error)
      }
    },
    resetAll() {
      this.questions = []
      this.answersData.user_response = []
      this.disable = true
      this.resetClick = true
      this.questions = _.cloneDeep(
        this.$store.state.profileQuestionnaire.questionnaire
      )
    },
  },
}
</script>

<template>
  <v-container>
    <v-row class="mt-4">
      <v-col
        cols="12"
        :class="$style.paddingclss"
        sm="12"
        md="12"
        lg="12"
        xl="12"
      >
        <h3 :class="$style.peerHeading">My Lifestyle & Goals</h3>
      </v-col>
      <v-col
        v-for="(question, i) in questions"
        :key="i"
        cols="12"
        :class="$style.paddingclss"
        sm="12"
        md="12"
        lg="12"
        xl="12"
      >
        <div class="submit-form">
          <v-form id="check-login-form" @submit.prevent="checkForm">
            <Checkbox
              v-if="question.question_type === 'checkbox'"
              v-model="question.answers"
              :question-id="question.question_id"
              :question-title="question.question_title"
              :question-options="question.question_options"
              :question-type="question.question_type"
              :selected="question.answers"
            ></Checkbox>
            <Button
              v-if="question.question_type === 'button'"
              v-model="question.answers"
              :question-id="question.question_id"
              :question-title="question.question_title"
              :question-options="question.question_options"
              :question-type="question.question_type"
              :selected="question.answers"
            ></Button>
            <Emoji
              v-if="question.question_type === 'Emojis'"
              v-model="question.answers"
              :question-id="question.question_id"
              :question-title="question.question_title"
              :question-options="question.question_options"
              :question-type="question.question_type"
              :selected="question.answers"
            ></Emoji>
            <Radio
              v-if="question.question_type === 'radiobutton'"
              v-model="question.answers"
              :question-id="question.question_id"
              :question-title="question.question_title"
              :question-options="question.question_options"
              :question-type="question.question_type"
              :selected="question.answers"
            ></Radio>
          </v-form>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-4"
      ><v-col
        cols="12"
        :class="$style.paddingclss"
        sm="12"
        md="12"
        lg="12"
        xl="12"
      >
        <v-btn
          type="submit"
          :disabled="disable"
          :class="$style.btnClass"
          form="check-login-form"
          >Save</v-btn
        >
        <p><a :class="$style.cancel" @click="resetAll">Cancel</a></p>
      </v-col></v-row
    >
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.paddingclss {
  padding: 0 0 10px 40px !important ;
}
.cancel {
  display: inline-block;
  margin: 26px 0 20px;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  background: none;
  border: none;
}
.btnClass {
  width: 240px;
  padding: 26px !important;
  font-size: 18px !important;
  font-weight: 600;
  color: #fff !important;
  text-transform: inherit;
  letter-spacing: inherit;
  background: #0476d9 !important;
  border: none;
  border-radius: 30px;
}
.peerHeading {
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: 400 !important;
  line-height: 38.13px !important;
}
@media screen and (max-width: 1263px) {
  .paddingclss {
    padding-left: 0 !important ;
  }
  .text {
    width: 100%;
  }
}

@media screen and (max-width: 959px) {
  .paddingclss {
    padding: 10px 20px 0 !important ;
  }
  .peerHeading {
    margin-bottom: 15px;
  }
}
@media screen and (max-width: 680px) {
  .btnClass {
    width: 100%;
  }
  .cancel {
    text-align: center;
  }
}
@media screen and (max-width: 479px) {
  .peerHeading {
    font-size: 26px;
    text-align: center;
  }
}
@media screen and (max-width: 385px) {
  .peerHeading {
    font-size: 22px;
  }
}
</style>
